import React, { memo } from "react";
import { TableCellProps } from "@mui/material";
import { cn } from "@/utils/common.utils";
import AppTabCell from "./AppTabCell";

const AppTableCellHeader = ({ children, ...otherProps }: TableCellProps) => {
  return <AppTabCell {...otherProps}>{children}</AppTabCell>;
};

export default memo(AppTableCellHeader);
